import React, {Component} from 'react';
import FAQs_Schema_org from "./FAQs_Schema_org";

class FAQs_component extends Component {
    
    constructor(props, context) {
        super(props, context);
        
        this.createListQuestions = this.createListQuestions.bind(this);
        this.createJSONSchema = this.createJSONSchema.bind(this);
        
    }
    
    createJSONSchema() {
        return {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": this.createListQuestions()
        }
    }
    
    createListQuestions() {
        return this.props.listQuestions.map((q,index) => {
            return (<div key={"faq-"+index}>
                <div className={"faq-one " + (this.props?.config?.smallInDesk?"smallInDesk":"")}>
                    <h3 className={"faq-page " + (this.props?.config?.smallInDesk?"smallInDesk":"")} dangerouslySetInnerHTML={{ __html: q.question }}/>
                    <div className={"faq-body " + (this.props?.config?.smallInDesk?"smallInDesk":"")}>
                        <p dangerouslySetInnerHTML={{ __html: q.answer }} />
                    </div>
                </div>
                <hr className="hr-line"/>
            </div>)
        })
    }
    
    render() {
        
        let title
        if(this.props.title){
            title = this.props.title
        }else if(this.props.name){
            title = `Preguntas frecuentes sobre <strong>${this.props.name}</strong>`
        }else{
            title = "Preguntas frecuentes"
        }
        
        
        return (
            <div>
                <h2 className={"faq-heading " + (this.props?.config?.smallInDesk ? "smallInDesk" : "")} dangerouslySetInnerHTML={{__html: title}}/>
                <section className="faq-container">
                    {this.createListQuestions()}
                </section>
                <FAQs_Schema_org
                    listQuestions={this.props.listQuestions}
                />
            </div>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
        const faq = document.getElementsByClassName("faq-page");
        let i;
        for (i = 0; i < faq.length; i++) {
            faq[i].addEventListener("click", function () {
                /* Toggle between adding and removing the "active" class,
                to highlight the button that controls the panel */
                this.classList.toggle("active");
                /* Toggle between hiding and showing the active panel */
                const body = this.nextElementSibling;
                if (body.style.display === "block") {
                    body.style.display = "none";
                } else {
                    body.style.display = "block";
                }
            });
        }
        
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default FAQs_component
